const development = {
    API_BASE_URL: "https://api.fundever.dev",
};

const qa = {
    API_BASE_URL: "https://api.fundever.xyz",
};

const getEnv = () => {
    switch (process.env.REACT_APP_ENV) {
        case "development":
            return development;
        case "qa":
            return qa;
        default:
            return development;
    }
};

module.exports.env = getEnv();
